import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import HomeAboutCarneiro from "../Components/Home_Components/HomeAbout";
import WineProduction from "../Components/Home_Components/WineProduction";
import BeerPricing from "../Components/Home_Components/BeerPricing";
import Testimonial from "../Components/Testimonial";
import LetsTalk from "../Components/Home_Components/LetsTalk";
import YouTubeShowcase from "../Components/Home_Components/YoutubeVideo";

// Wrapper animation for group staggering
const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.3,
    },
  },
};

// Individual letter animation
const letterVariant = {
  hidden: { opacity: 0, y: 40, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

const textEffect = (text, className) => (
  <motion.div
    variants={container}
    initial="hidden"
    animate="visible"
    className="flex space-x-1 sm:space-x-2"
  >
    {[...text].map((char, idx) => (
      <motion.span key={idx} variants={letterVariant} className={className}>
        {char === " " ? "\u00A0" : char}
      </motion.span>
    ))}
  </motion.div>
);

const Home = () => {
  const navigate = useNavigate();

  const WHATSAPP_LINK = "https://wa.me/919881055454";

  return (
    <>
      <div className="wine-landing-section min-h-[80vh] flex flex-col relative overflow-hidden">
        {/* Overlay */}
        <div className="absolute w-full h-full bg-gradient-to-t from-black to-transparent z-10"></div>

        {/* Main Content */}
        <div className="absolute top-1/2 left-[30%] -translate-x-[30%] -translate-y-1/2 z-20 px-4 text-left">
          {/* NOBLE */}
          <div className="relative">
            {textEffect(
              "NOBLE",
              "text-8xl md:text-9xl text-white font-extrabold drop-shadow-2xl"
            )}
          </div>

          {/* POUR + Subtext */}
          <div className="flex sm:justify-start items-center gap-4 text-left mt-4">
            {textEffect(
              "POUR",
              "text-7xl sm:text-8xl md:text-9xl text-white font-extrabold drop-shadow-2xl"
            )}

            <motion.h3
              initial={{ opacity: 0, y: 40, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ delay: 1.2, duration: 0.6, ease: "easeOut" }}
              className="capitalize text-lg leading-5 sm:text-xl sm:left-6 md:text-3xl md:leading-9 text-white/90 font-bold drop-shadow-2xl text-left"
            >
              taste <br />
              the <br />
              elegance
            </motion.h3>
          </div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.6, duration: 0.6, ease: "easeOut" }}
            className="flex flex-wrap gap-4 mt-10"
          >
            <button
              onClick={() => navigate("/products")}
              className="bg-[--accent-gold] hover:bg-[--accent-gold-dark] text-white font-semibold px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105"
            >
              Buy
            </button>

            <button
              onClick={() => window.open(WHATSAPP_LINK, "_blank")}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105"
            >
              Find Distributor
            </button>

            <button
              onClick={() => navigate("/contact")}
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[--primary-wine] font-semibold px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105"
            >
              Contact Sales Team
            </button>
          </motion.div>
        </div>
      </div>

      <HomeAboutCarneiro />
      <WineProduction />
      <BeerPricing />
      <YouTubeShowcase />
      <LetsTalk />
      <Testimonial />
      </>
  );
};

export default Home;
